module.exports = __webpack_public_path__ + "static/green-triangle-large-abbefd7bb863263750bbd7b423316456.png";